import { render, staticRenderFns } from "./ViewResellerPage.vue?vue&type=template&id=8db6d378"
import script from "./ViewResellerPage.vue?vue&type=script&lang=js"
export * from "./ViewResellerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports